export default [
  {
    path: '/index',
    redirect: '/',
    hidden: true
  },
  {
    path: '/',
    redirect: '/home1',
    hidden: true
  }
]
